import { useEffect } from 'react';

import { ApolloError } from '@apollo/react-hooks';
import {
  CMSContentPage,
  IUseContentPageOnCompletedResponse,
  useContentPage,
  useContentPageContext,
} from '@netfront/ekardo-content-library';
import { Breadcrumbs, IBreadcrumbItem } from '@netfront/ui-library';
import isEmpty from 'lodash.isempty';
import kebabCase from 'lodash.kebabcase';

import { Affiliates } from '../components/Affiliates';
import { BreadcrumbItemHomePageLink, BreadcrumbItem } from '../components/BreadcrumbItems';
import { HelpButton } from '../components/HelpButton';
import { PageLayout } from '../components/PageLayout';
import { useToast } from '../hooks/useToast';

const PAGE_TITLE = 'Privacy statement';

const BREADCRUMB_ITEMS: IBreadcrumbItem[] = [
  {
    content: <BreadcrumbItemHomePageLink />,
    key: 'home',
  },
  {
    content: <BreadcrumbItem text={PAGE_TITLE} />,
    key: kebabCase(PAGE_TITLE),
  },
];

const PrivacyStatementPage = () => {
  const { dispatch, state: currentContentPage } = useContentPageContext();
  const { handleToastError } = useToast();

  const handleGetContentPageCompleted = (data: IUseContentPageOnCompletedResponse) => {
    const { contentPage } = data;

    dispatch({
      payload: {
        contentPage,
      },
      type: 'loadContentPage',
    });
  };

  const handleGetContentPageError = (error: ApolloError) => {
    handleToastError({
      shouldUseFriendlyErrorMessage: true,
      error,
    });
  };

  const { handleGetContentPage, isLoading } = useContentPage({
    onCompleted: handleGetContentPageCompleted,
    onError: handleGetContentPageError,
  });

  useEffect(() => {
    handleGetContentPage({
      contentPageId: 123413,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageLayout isPreloaderVisible={isLoading} title={PAGE_TITLE}>
      <div className="container-md flex justify-end py-8">
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </div>

      <div className="container-md pb-8 pt-4">
        <div className="flex flex-col mb-4 md:flex-row">
          <div className="md:w-3/4 w-full">
            <h1 className="color-accent h4 mb-2 weight-800">{PAGE_TITLE}</h1>
            <h2 className="color-blue-900 h2">CarerWell Program and Website</h2>
          </div>

          <div className="align-center flex md:third w-full">
            <div className="bg-grey-100 flex-1 h-0-5 mx-8 radius-full" role="presentation" />
            <HelpButton />
          </div>
        </div>
      </div>

      {!isEmpty(currentContentPage) && (
        <section className="pt-8 pb-12">
          <div className="container-md">
            <CMSContentPage />
          </div>
        </section>
      )}

      <Affiliates />
    </PageLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default PrivacyStatementPage;
